import React from "react"

import PropTypes from "prop-types"

import {texts} from "./texts"

import "./style.scss"

const ContactBanner = ({contactLink}) => (
    <section aria-label={texts.contactBannerAriaLabel} className="contact-banner">
        <span>{texts.contactBanner}</span>
        <a aria-label={texts.contactBannerLinkAriaLabel} href={contactLink} rel="noopener noreferrer" target="_blank">
            {texts.contactBannerLink}
        </a>
    </section>
)

ContactBanner.propTypes = {
    contactLink: PropTypes.string.isRequired,
}

export default ContactBanner
